// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./overiew\"></require>\n  <overview mooring-id.bind=\"data.mooringId\" offer-id.bind=\"data.offerId\"></overview>\n</template>\n";
// Exports
export default code;